import React, { Component } from 'react';
import Lottie from 'react-lottie';
import logo from "images/logo-white.png"
import potatosAtWork from '../animations/potatosAtWork.js';

class Maintenance extends Component {
    static displayName = Maintenance.name;
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <div className={`d-flex justify-content-center align-items-center`} style={{ backgroundColor: "black", width: "100vw", height: "100vh" }}>
                <div style={{
                    width: "auto",
                    height: "auto",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "2rem"
                }}>
                    <img src={logo} alt="logo" style={{ maxWidth: "300px", width: "100%" }} />
                    <div>
                        <h2 style={{ color: "white", margin: "0.5rem 0" }}>We're making some updates,</h2>
                        <h2 style={{ color: "white", margin: "0.5rem 0" }}>check back again soon!</h2>
                    </div>
                </div>
            </div>
        );
    }
}
export default Maintenance;